"use client";

import { useState } from "react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { RECETTES, type Recette } from "@/lib/diwline-data";
import { ChefHat, Droplets } from "lucide-react";

export function Recettes() {
  const [active, setActive] = useState<Recette | null>(null);

  return (
    <section id="recettes" className="relative bg-gradient-to-b from-royal via-royal-brown to-royal py-24 md:py-32 bg-arabesque" aria-label="Recettes Royales">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="V"
          titre="Recettes Royales"
          intro="Les grands chefs sénégalais et africains révèlent leurs recettes signature sublimées par les huiles prestige DIW'LINE. Du Thieboudienne royal aux beignets de karité peuls — l'or liquide au service de la gastronomie noble."
        />

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {RECETTES.map((r, i) => (
            <Reveal key={r.titre} delay={i * 0.07} className="h-full">
              <article
                className={`group h-full overflow-hidden rounded-sm border bg-royal-brown transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_22px_60px_rgba(212,175,55,0.14)] ${
                  active?.titre === r.titre ? "border-gold/70" : "border-gold/20 hover:border-gold/55"
                }`}
              >
                <button type="button" onClick={() => setActive(active?.titre === r.titre ? null : r)} className="block w-full text-left" aria-expanded={active?.titre === r.titre}>
                  <div className="relative overflow-hidden">
                    <img
                      src={r.image}
                      alt={r.titre}
                      className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-107"
                    />
                    <span className="absolute top-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-black/60 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-light backdrop-blur-sm">
                      <Droplets className="h-3 w-3" aria-hidden />
                      {r.huile}
                    </span>
                  </div>
                  <div className="p-6">
                    <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-gold/80">
                      <ChefHat className="h-3.5 w-3.5" aria-hidden />
                      {r.chef}
                    </p>
                    <h3 className="mt-2 font-display text-xl font-semibold text-cream group-hover:text-gold-light transition-colors">
                      {r.titre}
                    </h3>
                    <p
                      className={`mt-3 text-[13px] leading-relaxed text-cream/70 transition-all ${
                        active?.titre === r.titre ? "" : "line-clamp-2"
                      }`}
                    >
                      {r.description}
                    </p>
                    <span className="mt-4 inline-block text-[11px] font-semibold uppercase tracking-[0.25em] text-gold">
                      {active?.titre === r.titre ? "Replier la recette" : "Lire la recette royale"}
                    </span>
                  </div>
                </button>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
